import React from 'react'
import { useIntl } from 'react-intl'
import { css, cx } from '@emotion/css'
import {
  SkeletorIcon,
  theme,
  IconClose
} from '@contrast-security-inc/design-system-foundations'
import { Text } from '@contrast-security-inc/design-system-typography'

export const closeIconDataTestID = 'policy-management-form-header-close-icon'

export const detailRendererContainerCss = css`
  padding-top: 4px;
  padding-left: 32px;
  color: ${theme.color.neutral50};
`

const closeIconContainerCss = css`
  padding-right: 20px;
  float: right;
  cursor: pointer;
`

// replicates the legacy styling usage (in the angularJS version) located at sass/bootstrap/_scaffolding.scss, line 133
const getHrCss = (marginBottom: number = 20) => css`
  margin-top: 20px;
  margin-bottom: ${marginBottom}px;
  border: 0;
  border-top: 1px solid ${theme.color.neutral30};
`

interface Props {
  readonly i18nID: string
  readonly Icon: SkeletorIcon
  readonly detailRenderer?: () => React.ReactNode
  readonly onClose: () => void
  readonly marginBottom?: number
}

export const PolicyManagementFormHeader: React.FC<Props> = ({
  i18nID,
  Icon,
  detailRenderer,
  onClose,
  marginBottom
}) => {
  const title = useIntl().formatMessage({
    id: i18nID
  })

  return (
    <div
      className={css`
        margin-top: 12px;
      `}
    >
      <div
        className={css`
          margin-left: 12px;
          margin-bottom: 20px;
        `}
      >
        <div className={closeIconContainerCss} onClick={onClose}>
          <IconClose
            className="policy-management-form-header-close-icon"
            testId={closeIconDataTestID}
            size="sm"
            color="neutral100"
          />
        </div>
        <div
          className={css`
            display: flex;
            align-items: center;
          `}
        >
          <Icon size="md" color="neutral70" />
          <Text
            font="titleH5"
            className={cx(
              'policy-management-form-header-title',
              css`
                padding-left: 8px;
              `
            )}
            data-e2e="autoverification-policy-form-header"
          >
            {title}
          </Text>
        </div>
        {detailRenderer && detailRenderer()}
      </div>
      <hr
        className={cx(
          css`
            width: 99%;
          `,
          getHrCss(marginBottom)
        )}
      />
    </div>
  )
}
